export default __webpack_public_path__ + "static/media/bannerDesktop2.90ed8471.png";